"use strict";

var window = require("global");

var LISTENER_LIST = [];

module.exports = {
	addOrientationListener: addOrientationListener,
	removeOrientationListener: removeOrientationListener,
	addSpecificOrientationListener: addSpecificOrientationListener,
	removeSpecificOrientationListener: removeSpecificOrientationListener,
	lockToPortrait: lockToPortrait,
	lockToLandscape: lockToLandscape,
	lockToLandscapeLeft: lockToLandscapeLeft,
	lockToLandscapeRight: lockToLandscapeRight,
	unlockAllOrientations: unlockAllOrientations,
	getOrientation: getOrientation,
	getSpecificOrientation: getSpecificOrientation,
};

function addOrientationListener(callback) {
	if(!hasOrientation()) return;
	var screen = window.screen;
	if(!screen) return;

	window.addEventListener("orientationchange", handleChange);
	LISTENER_LIST.push({
		callback: callback,
		listener: handleChange
	});

	function handleChange(){
		var orientation = screen.orientation.type;
		var currentOrientation = null;

		if(orientation === "portrait-primary" || orientation === "portrait")
			currentOrientation = "PORTRAIT";
		else if(orientation === "portrait-secondary")
			currentOrientation = "PORTRAITUPSIDEDOWN";
		else if(orientation === "landscape" || orientation === "landscape-primary" || orientation === "landscape-secondary")
			currentOrientation = "LANDSCAPE";
		else currentOrientation = "UNKNOWN";

		callback(currentOrientation);
	}
}

function removeOrientationListener(callback){
	if(!hasOrientation()) return;
	var screen = window.screen;
	if(!screen) return;

	var pair = LISTENER_LIST.reduce(function(result, current){
		if(result) return result;
		if(current.callback === callback)
			return current;
		return null;
	}, null);

	if(!pair) return;

	// Remove pair from the LISTENER_LIST
	LISTENER_LIST.splice(LISTENER_LIST.indexOf(pair), 1);

	window.removeEventListener("orientationchange", pair.listener);
}

function addSpecificOrientationListener(callback){
	if(!hasOrientation()) return;
	var screen = window.screen;
	if(!screen) return;
	window.addEventListener("orientationchange", handleChange);

	LISTENER_LIST.push({
		callback: callback,
		listener: handleChange
	});

	function handleChange(){
		var orientation = screen.orientation.type;
		var currentOrientation = null;

		if(orientation === "portrait-primary" || orientation === "portrait")
			currentOrientation = "PORTRAIT";
		else if(orientation === "portrait-secondary")
			currentOrientation = "PORTRAITUPSIDEDOWN";
		else if(orientation === "landscape" || orientation === "landscape-primary")
			currentOrientation = "LANDSCAPE-LEFT";
		else if(orientation === "landscape-secondary")
			currentOrientation = "LANDSCAPE-RIGHT";
		else currentOrientation = "UNKNOWN";

		callback(currentOrientation);
	}
}

function removeSpecificOrientationListener(callback){
	if(!hasOrientation()) return;
	var screen = window.screen;
	if(!screen) return;

	var pair = LISTENER_LIST.reduce(function(result, current){
		if(result) return result;
		if(current.callback === callback)
			return current;
		return null;
	}, null);

	if(!pair) return;

	// Remove pair from the LISTENER_LIST
	LISTENER_LIST.splice(LISTENER_LIST.indexOf(pair), 1);

	window.removeEventListener("orientationchange", pair.listener);
}

function lockToPortrait(){
	doLock("portrait-primary");
}

function lockToLandscape(){
	doLock("landscape");
}

function lockToLandscapeLeft(){
	doLock("landscape-primary ");
}

function lockToLandscapeRight(){
	doLock("landscape-secondary ");
}

function unlockAllOrientations(){
	if(!hasOrientation()) return;
	var screen = window.screen;
	if(!screen) return;
	if(screen.unlockOrientation){
		screen.unlockOrientation();
	} else if(screen.orientation){
		screen.orientation.unlock();
	}
}

function getOrientation(callback){
	if(!hasOrientation()) return;
	var screen = window.screen;
	if(!screen) return;
	var currentOrientation = null;
	var error = null;
	var orientation = screen.orientation.type;
	if(orientation === "portrait-primary" || orientation === "portrait")
		currentOrientation = "PORTRAIT";
	else if(orientation === "portrait-secondary")
		currentOrientation = "PORTRAITUPSIDEDOWN";
	else if(orientation === "landscape" || orientation === "landscape-primary" || orientation === "landscape-secondary")
		currentOrientation = "LANDSCAPE";
	else {
		error = "unknown error";
		currentOrientation = "UNKNOWN";
	}
	callback && callback(error, currentOrientation);
}

function getSpecificOrientation(callback){
	if(!hasOrientation()) return;
	var screen = window.screen;
	if(!screen) return;
	var currentOrientation = null;
	var error = null;
	var orientation = getRawOrientation().type;

	if(orientation === "portrait-primary" || orientation === "portrait")
		currentOrientation = "PORTRAIT";
	else if(orientation === "portrait-secondary")
		currentOrientation = "PORTRAITUPSIDEDOWN";
	else if(orientation === "landscape" || orientation === "landscape-primary")
		currentOrientation = "LANDSCAPE-LEFT";
	else if(orientation === "landscape-secondary")
		currentOrientation = "LANDSCAPE-RIGHT";
	else {
		error = "unknown error";
		currentOrientation = "UNKNOWN";
	}
	callback && callback(error, currentOrientation);
}

function doLock(orientation) {
	if(!hasOrientation()) return;
	var screen = window.screen;
	if(!screen) return;
	if(screen.lockOrientation){
		screen.lockOrientation(orientation);
	} else if(screen.orientation){
		try {
			screen.orientation.lock(orientation);
		} catch (e) {
			// Not a compatible device
		}
	}
	recheckScreenOrientation();
}

function recheckScreenOrientation() {
	if(!hasOrientation()) return;
	var cordova = window.cordova;
	if(!cordova) return;
	if(cordova.recheckScreenOrientation){
		cordova.recheckScreenOrientation();
	}
}

function getRawOrientation() {
	if(!hasOrientation()) return;
	var screen = window.screen;
	return screen.orientation || screen.mozOrientation || screen.msOrientation || {};
}

function hasOrientation() {
	return window.screen && window.screen.orientation;
}
